import { action, observable, computed, toJS } from 'mobx';
import { formatDate } from '../utility'

const STORE_STATS = 'stats';

class StatsStore {
  constructor(rawState = {}) {

    if(rawState.items) {
      this.setItems(rawState.items);
    }
    if(rawState.from) {
      this.setFrom(rawState.from);
    } else {
      const from = new Date();
      from.setMonth(from.getMonth() - 1);
      this.setFrom(from);
    }
    if(rawState.to) {
      this.setTo(rawState.to);
    } else {
      const now = new Date();
      this.setTo(now);
    }
    if(rawState.itemId) {
      this.setItemId(rawState.itemId);
    }
  }
  toJS() {
    return {
      items: toJS(this.items),
      from: toJS(this.from),
      to: toJS(this.to),
      itemId: toJS(this.itemId)
    };
  }

  @observable items = [];
  @action setItems(value) {
    this.items = value;
  }

  @observable from;
  @action setFrom(value) {
    this.from = value;
  }
  @computed get fromFormatted() {
    return formatDate(this.from);
  }

  @observable to;
  @action setTo(value) {
    this.to = value;
  }
  @computed get toFormatted() {
    return formatDate(this.to);
  }

  @observable itemId;
  @action setItemId(value) {
    this.itemId = value;
  }
}

export { StatsStore, STORE_STATS };